import $ from 'jquery';
import _ from 'underscore';
import BaseView from 'picnic/core/views/Base';
import Slideshow from 'app/cms/carpricechecker/views/result/Slideshow';


class View extends BaseView {

	get userFilterIsOpen() {
		return this.$el.find('.user-filter').hasClass('is-open');
	}

	set userFilterIsOpen(value) {
		this.$el.find('.user-filter').toggleClass('is-open', value);
	}

	render() {
		super.render();
		this._bindEvents();

		this._slideshow = new Slideshow({
			el: this.$el,
			context: this.context
		}).render();

		return this;
	}

	_bindEvents() {
		_.bindAll(
			this,
			'_onScrollToCarpricechecker',
			'_onToggleUserFilter'
		);

		this.$el.on('click', '.content-notification a', this._onScrollToCarpricechecker);
		this.$el.on('click', '.user-filter h2', this._onToggleUserFilter);
		$(window).on('resize', this._onResize);
	}

	_onToggleUserFilter(event) {
		event.preventDefault();
		this.userFilterIsOpen = !this.userFilterIsOpen;
	}

	_onScrollToCarpricechecker(event) {
		event.preventDefault();
		this.context.dispatch('scrollToCarpricechecker:cpc-warning');
	}
}

export default View;
